function shuffle(array) {
    var m = array.length, t, i;
    while (m) {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
}

export function loadScribbles(scribbles) {
    shuffle(scribbles);
    let scribbleDivs = document.querySelectorAll(".border-scribble");
    for (let i = 0; i < scribbleDivs.length; i++) {
        scribbleDivs[i].style.backgroundImage=`url(${scribbles[i]})`;
    }
}

export function loadBackgroundColor() {
  let random_idx = Math.floor(Math.random() * 7);
  let randomColor = getComputedStyle(document.documentElement).getPropertyValue('--c' + random_idx);
  let randomColorTransparent = getComputedStyle(document.documentElement).getPropertyValue('--c' + random_idx + '-b');
  document.querySelector("html").style.setProperty('--random-color', randomColor);
  document.querySelector("html").style.setProperty('--random-color-b', randomColorTransparent);
}


export function displayOptionsOnClick() {
    let displayOptionsList = qs("#display-options ul");
    displayOptionsList.classList.toggle("hidden-display-list");
    let displayBtn = qs("#display-btn");
    displayBtn.classList.toggle("display-btn-options-out");
}


export function getCurHTML() {
    return this.innerHTML;
}

/**
 * Returns the first element that matches the given CSS selector.
 * @param {string} selector - CSS query selector
 * @returns {object} the first DOM object matching the query (empty if none).
 */
function qs(selector) {
  return document.querySelector(selector);
}
